import { getListingsById } from '../../ducks/marketplaceData.duck';

/**
 * Shared mapStateToProps factory for handyman pages.
 * Each page (HandymanPage, HandymanTorontoPage, HandymanCityPage,
 * HandymanTorontoServicePage) stores its own listing query result under a
 * dedicated state slice — pass that slice name here to get a consistent
 * { listings, queryInProgress, queryListingsError } prop shape.
 */
export const createHandymanMapStateToProps = stateSliceName => state => {
  const slice = state[stateSliceName] || {};
  const {
    currentPageResultIds = [],
    queryInProgress = false,
    queryListingsError = null,
  } = slice;
  const listings = getListingsById(state, currentPageResultIds);

  return {
    listings,
    queryInProgress,
    queryListingsError,
  };
};
